import { DateFormatter } from '@/support/DateFormatter';
import { Component, Prop, Vue } from 'vue-property-decorator';
import OverwriteDateDialog from '@/components/OverwriteDateDialog/OverwriteDateDialog.vue';
import { OverwriteDateEvent } from '../OverwriteDateDialog/OverwriteDateDialog';

@Component<DatePlanningInput>({
  components: {
    OverwriteDateDialog,
  },
})
export default class DatePlanningInput extends Vue {
  // #region @Props

  @Prop({ default: '' })
  protected title!: string;

  @Prop({ default: true })
  protected canEdit!: boolean;

  @Prop({ default: null })
  protected date!: string | null;

  @Prop({ default: null })
  protected originalDate!: string | null;

  @Prop({ default: 'Originele datum' })
  protected originalDateLabel!: string;

  // #endregion

  // #region @Refs
  // #endregion

  // #region Class properties

  protected isEditingDate = false;

  protected isOverwritingDate = false;

  protected internalDate: DateFormatter = new DateFormatter();

  // #endregion

  // #region Lifecycle Hooks / Init

  // #endregion

  // #region Class methods

  protected updateDate(): void {
    const newDate = `${this.internalDate.selectedDate} ${this.internalDate.selectedTime}`;
    this.$emit('updateDate', newDate);
  }

  protected onOverwriteDate(event: OverwriteDateEvent): void {
    this.$emit('overwriteDate', event);
  }

  protected onClickEdit(): void {
    if (this.dateIsScheduled) {
      this.isOverwritingDate = true;
      return;
    }

    this.isEditingDate = ! this.isEditingDate;
  }

  // #endregion

  // #region Async methods

  // #endregion

  // #region Getters & Setters

  protected get originalDateIsScheduled(): boolean {
    return !! this.originalDate;
  }

  protected get dateIsScheduled(): boolean {
    return !! this.date;
  }

  // #endregion

  // #region @Watchers

  // #endregion
}

export type UpdateDateRequest = {
  field: string;
  date: string;
}

export type OverwriteDateRequest = {
  field: string;
  event: OverwriteDateEvent;
}
